import { sfGet, sfPatch, sfPost } from "./salesforceApi";
import {
  fromSalesforceProjectPage,
  toSalesforceProjectPage,
} from "../schema/projectPageSchema";
import { getEnv } from "../config/getEnv";

const PP_RESOURCE = getEnv("REACT_APP_SF_PP_RESOURCE") || "/ProjectPage";

export async function fetchProjectPage(projectPageId) {
  if (!projectPageId)
    throw new Error("fetchProjectPage requires a projectPageId");
  const data = await sfGet(`${PP_RESOURCE}`, { id: String(projectPageId) });
  const record = Array.isArray(data) ? data[0] : data;
  return fromSalesforceProjectPage(record || {});
}

export async function fetchProjectPagesByProjectId(projectId) {
  if (!projectId)
    throw new Error("fetchProjectPagesByProjectId requires a projectId");
  const data = await sfGet(`${PP_RESOURCE}`, { pid: String(projectId) });
  return Array.isArray(data) ? data : [];
}

export async function fetchProjectPagesByProjectObjectiveId(
  projectObjectiveId,
) {
  if (!projectObjectiveId)
    throw new Error(
      "fetchProjectPagesByProjectObjectiveId requires a projectObjectiveId",
    );
  const data = await sfGet(`${PP_RESOURCE}`, {
    poid: String(projectObjectiveId),
  });
  return Array.isArray(data) ? data : [];
}

export async function searchProjectPages(searchKey) {
  const key = String(searchKey || "").trim();
  if (key.length === 0) return [];
  const data = await sfGet(`${PP_RESOURCE}`, { searchkey: key });
  return Array.isArray(data) ? data : [];
}

export async function fetchAllProjectPages() {
  try {
    const data = await sfGet(`${PP_RESOURCE}`, { searchkey: "all" });
    return Array.isArray(data) ? data : [];
  } catch (err) {
    throw err;
  }
}

export async function patchProjectPage(projectPageId, uiRecord) {
  if (!projectPageId) throw new Error("patchProjectPage requires an id");
  const payload = toSalesforceProjectPage(uiRecord || {});
  return sfPatch(`${PP_RESOURCE}`, payload, {
    params: { id: String(projectPageId) },
  });
}

/**
 * Create a new individual Project Page
 * @param {Object} uiRecord - UI form data
 * @returns {Promise<Object>} Created project page response
 */
export async function createIndividualProjectPage(uiRecord) {
  try {
    console.log("🎯 Creating individual project page with data:", uiRecord);

    const payload = {
      Name: uiRecord.projectPageName || uiRecord.name || "",
      Project_Page_Type__c: uiRecord.projectPageType || "",
      Project_Qualification_Step__c: uiRecord.projectQualStep || "",
      Active__c: uiRecord.active || false,
      Project_Page_Description__c: uiRecord.projectPageDescription || "",
      // Prefer Id values captured via SearchableLookupField
      Project__c: uiRecord.projectId || uiRecord.project || "",
      Project_Objective__c:
        uiRecord.projectObjectiveId || uiRecord.projectObjective || "",
    };

    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === null ||
        payload[key] === "" ||
        payload[key] === undefined
      ) {
        delete payload[key];
      }
    });

    console.log("📤 Sending payload to Salesforce:", payload);

    const response = await sfPost(`${PP_RESOURCE}`, payload);

    console.log("✅ Project Page created successfully:", response);

    return response;
  } catch (error) {
    console.error("❌ Error creating project page:", error);
    throw error;
  }
}
